define('app/collections/minicart_items',['app/setup'], function(takhfifan) {

  takhfifan.MinicartItems = Backbone.Collection.extend({

    model: takhfifan.MinicartItem

  });
});

